
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return import('components/clamp-text/clamp-text');
    },
    true
);

webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return import('components/clamp-text/clamp-text');
    },
    true
);